import $ from 'jquery'

var formMaterialDesign = function($element) {
  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $textfield,
      $select;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $textfield = $('.form-field__input, .form-field__textarea', $mainContainer);
    $select = $('.custom-select.material-design', $mainContainer);

    unmaskPassword();
    hintPassword();

    bindDomEvents();
  }

  function bindDomEvents() {
    checkInputState();

    $('.form-field__control', $mainContainer).on('click', function(){
      $('.form-field__input, .form-field__textarea', $(this)).trigger('focus');
    });

    $textfield.on('blur', function(){
      setActive($(this), false);
    });

    $textfield.on('focus', function(){
      if (!$(this).parents('.form-field').hasClass('form-field--is-disabled')) {
        setActive($(this), true)
      }
    });

    $('input[autofocus="autofocus"]', $mainContainer).trigger('focus');

    $select.each(function(){
      selectSet($(this));
    });

    $('select', $select).on('change', function(){
      selectSet($(this).parents('.custom-select'));
    });

    $('select', $select).on('focus', function(){
      if (!$(this).parents('.form-field').hasClass('form-field--is-disabled')) {
        setActiveSelect($(this), true);
      }
    });

    $('select', $select).on('blur', function(){
      setActiveSelect($(this), false);
    });
  }

  function unmaskPassword() {
    $('input:password', $mainContainer).each((i, el) => {
      var $passwordField = $(el),
          $passwordWrapper = $passwordField.parent(),
          $eyeIconHtml = $('<i class="eye-unmask-password fas fa-eye-slash" tabindex="0"></i>');

      $passwordWrapper.append($eyeIconHtml);

      var $eyeIcon = $('.eye-unmask-password', $passwordWrapper)

      $eyeIcon.on('click', (e) => {
        showHidePassword(e)
      })
      $eyeIcon.on('keyup', (e) => {
        if ( e.keyCode === $.ui.keyCode.ENTER ) {
          showHidePassword(e)
        }
      })
    })
  }

  function hintPassword() {
    var $passwordWrapper = $('.password-with-hint', $mainContainer);
    var $passwordField = $('input', $passwordWrapper);
    var hintHtml = `<ul class='password-hint-list'><li>` +
                    `<li><i class='icon-checkmark eight-char'></i>At least 8 characters</li>` +
                    `<li><i class='icon-checkmark one-letter'></i>At least 1 letter</li>` +
                    `<li><i class='icon-checkmark one-num'></i>At least 1 number</li>` +
                    `<li><i class='icon-checkmark one-spec'></i>At least 1 special character (for example: ! * $ @)</li>` +
                    `</ul>`;

    if ($('.password-hint-list', $passwordWrapper).length < 1) {
      $passwordWrapper.append(hintHtml);
    }

    $passwordField.on('keyup', () => {
      var password = $passwordField.val()

      if (password.length >= 8) {
        $('.eight-char', $passwordWrapper).addClass('checked');
      } else {
        $('.eight-char', $passwordWrapper).removeClass('checked');
      }

      // At least 1 number
      if (password.match(/(?=.*\d)/)) {
        $('.one-num', $passwordWrapper).addClass('checked');
      } else {
        $('.one-num', $passwordWrapper).removeClass('checked');
      }

      // At least 1 special character
      if (password.match(/([^A-Za-z0-9])/)) {
        $('.one-spec', $passwordWrapper).addClass('checked');
      } else {
        $('.one-spec', $passwordWrapper).removeClass('checked');
      }

      // At least 1 letter
      if (password.match(/([A-Za-z])/)) {
        $('.one-letter', $passwordWrapper).addClass('checked');
      } else {
        $('.one-letter', $passwordWrapper).removeClass('checked');
      }

    });
  }

  function showHidePassword(e) {
    var $link = $(e.target),
        $passwordInput = $link.prev()

    if ($passwordInput.attr('type')==='password') {
      $passwordInput.attr('type','text');
      $link.addClass('fa-eye').removeClass('fa-eye-slash')
    } else {
      $passwordInput.attr('type','password');
      $link.addClass('fa-eye-slash').removeClass('fa-eye')
    }
  }

  function setActive($el, active) {
    var $formField = $el.parents('.form-field');

    if (active) {
      $formField.addClass('form-field--is-active');
    } else {
      $formField.removeClass('form-field--is-active');
      $el.val() === '' ?
        $formField.removeClass('form-field--is-filled') :
        $formField.addClass('form-field--is-filled');
    }
  }

  function setActiveSelect($el, active) {
    var $formField = $el.parents('.custom-select');

    if (active) {
      $formField.addClass('form-field--is-active');
    } else {
      $formField.removeClass('form-field--is-active');
    }
  }

  function checkInputState() {
    $('.form-field', $mainContainer).each(function(){
      var $formField = $(this);

      if ($('input', $formField).val() != "") {
        $formField.addClass('form-field--is-filled');
      }

      if ($('textarea', $formField).text() != "") {
        $formField.addClass('form-field--is-filled');
      }

      if ($('input', $formField).attr('disabled') == "disabled") {
        $formField.addClass('form-field--is-disabled');
      } else {
        $formField.removeClass('form-field--is-disabled');
      }
    });

    $('input', $mainContainer).on('change', function(){
      var $el = $(this),
          $formField = $el.parents('.form-field');
      if ($el.val() != "") {
        $formField.addClass('form-field--is-filled');
      }
    });

    $('textarea', $mainContainer).on('change', function(){
      var $el = $(this),
          $formField = $el.parents('.form-field');
      if ($el.text() != "") {
        $formField.addClass('form-field--is-filled');
      }
    });
  }

  function selectSet(el) {
    var $wrapper = el,
        $label = $('.form-field__label', $wrapper),
        $select = $('select', $wrapper);

    if ($wrapper.next('.form-field__errors').length > 0) {
      $wrapper.addClass('field_with_errors');
    }

    if ($('option:selected', $select).text() == $label.text() || $('option:selected', $select).text() == '') {
      $wrapper.removeClass('form-field--is-filled');
    } else {
      $wrapper.addClass('form-field--is-filled');
    }
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
};

// jQuery plugin method
$.fn.formMaterialDesign = function(options) {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('formMaterialDesign')) {
      $this.data('formMaterialDesign', formMaterialDesign($this, options));
    }
  });
};
